module.exports = __webpack_public_path__ + "img/自助机照片.67635e42.png";